import { getAppEnv } from "../lib/getEnvVariables";
export const baseUrls = {
    assetsV2Api: {
        alwaysPassThrough: true,
        url: "https://services.cat.com/catDigital/assets/v2"
    },
    baasV2ApiDev: {
        alwaysPassThrough: true,
        url: "https://api-dev.cat.com/catDigital/baass/v2"
    },
    baasV2ApiInt: {
        alwaysPassThrough: true,
        url: "https://api-int.cat.com/catDigital/baass/v2"
    },
    baasV2ApiProd: {
        alwaysPassThrough: true,
        url: "https://services.cat.com/catDigital/baass/v2"
    },
    caasClientV1Api: {
        alwaysPassThrough: true,
        url: "https://api.cat.com/catDigital/caasClient/v1"
    },
    caasV1ApiDev: {
        alwaysPassThrough: true,
        url: "https://api.cat.com/catDigital/caas/v1"
    },
    cdnCookieApis: {
        alwaysPassThrough: true,
        url: "https://cdn.cookielaw.org"
    },
    clickTrackingApi: {
        alwaysPassThrough: true,
        url: "https://stats.g.doubleclick.net"
    },
    eflowV1ApiDev: {
        alwaysPassThrough: true,
        url: "https://api.cat.com/catDigital/eflow/v1"
    },
    eflowV1ApiInt: {
        alwaysPassThrough: true,
        url: "https://api-int.cat.com/catDigital/eflow/v1"
    },
    eflowV1ApiProd: {
        alwaysPassThrough: true,
        url: "https://api.cat.com/catDigital/eflow/v1"
    },
    entitlementsV1Api: {
        alwaysPassThrough: true,
        url: "https://api.cat.com/catDigital"
    },
    fontsGoogleApis: {
        alwaysPassThrough: true,
        url: "https://fonts.googleapis.com"
    },
    geolocationAPi: {
        alwaysPassThrough: true,
        url: "https://geolocation.onetrust.com"
    },
    googleAnalyticsApi: {
        alwaysPassThrough: true,
        url: "https://www.google-analytics.com"
    },
    mapsGoogleApis: {
        alwaysPassThrough: true,
        url: "https://maps.googleapis.com"
    },
    privacyPortalApi: {
        alwaysPassThrough: true,
        url: "https://privacyportal.onetrust.com"
    },
    self: {
        alwaysPassThrough: true,
        url: "/"
    },
    signInCat: {
        alwaysPassThrough: true,
        url: "https://signin.cat.com"
    },
    whatFix: {
        alwaysPassThrough: true,
        url: "https://*.whatfix.com"
    }
};
export const baseUrlsList = Object.keys(baseUrls).map((baseUrl) => baseUrls[baseUrl]);
export const endpoints = {
    caasProjectDetail: {
        baseUrl: baseUrls.caasV1ApiDev,
        getUrl: (id, queryParams) => `/projects/${id}/assets/search${queryParams && "?" + queryParams}`,
        path: "/projects/:projectId/assets/search"
    },
    caasProjectEnergyHistogram: {
        baseUrl: baseUrls.caasV1ApiDev,
        getUrl: (id) => `/projects/${id}/energy/histogram`,
        path: "/projects/:projectId/energy/histogram"
    },
    caasProjectEnergyMetrics: {
        baseUrl: baseUrls.caasV1ApiDev,
        getUrl: (id) => `/projects/${id}/energy/metrics`,
        path: "/projects/:projectId/energy/metrics"
    },
    caasProjectNetworkConnections: {
        baseUrl: baseUrls.caasV1ApiDev,
        getUrl: (id) => `/projects/${id}/network/connections`,
        path: "/projects/:projectId/network/connections"
    },
    caasProjectsSearch: {
        baseUrl: baseUrls.caasV1ApiDev,
        getUrl: (queryParams) => `/projects/search${queryParams && "?" + queryParams}`,
        path: "/projects/search"
    },
    eflowAssetsChargeOptionsDev: {
        baseUrl: baseUrls.eflowV1ApiDev,
        getUrl: () => `/assets/chargeOptions`,
        path: "/assets/chargeOptions"
    },
    eflowAssetsChargeOptionsInt: {
        baseUrl: baseUrls.eflowV1ApiInt,
        getUrl: () => `/assets/chargeOptions`,
        path: "/assets/chargeOptions"
    },
    eflowAssetsChargeOptionsProd: {
        baseUrl: baseUrls.eflowV1ApiProd,
        getUrl: () => `/assets/chargeOptions`,
        path: "/assets/chargeOptions"
    }
};
export const endpointsList = Object.keys(endpoints).map((endpoint) => endpoints[endpoint]);
export const getEflowBaseUrl = () => {
    switch (getAppEnv()) {
        case "dev":
            return baseUrls.eflowV1ApiDev.url;
        case "int":
            return baseUrls.eflowV1ApiInt.url;
        case "prod":
            return baseUrls.eflowV1ApiProd.url;
        default:
            return baseUrls.eflowV1ApiDev.url;
    }
};
export const getBaasBaseUrl = () => {
    switch (getAppEnv()) {
        case "dev":
            return baseUrls.baasV2ApiDev.url;
        case "int":
            return baseUrls.baasV2ApiInt.url;
        case "prod":
            return baseUrls.baasV2ApiProd.url;
        default:
            return baseUrls.baasV2ApiDev.url;
    }
};
